import { render, staticRenderFns } from "./DatingTabMob.vue?vue&type=template&id=ae08fc56&scoped=true"
import script from "./DatingTabMob.vue?vue&type=script&lang=js"
export * from "./DatingTabMob.vue?vue&type=script&lang=js"
import style0 from "./DatingTabMob.vue?vue&type=style&index=0&id=ae08fc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae08fc56",
  null
  
)

export default component.exports